import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataServiceService } from '../../services/data-service.service';

@Component({
  selector: 'app-customer-load-details',
  templateUrl: './customer-load-details.component.html',
  styleUrl: './customer-load-details.component.scss'
})

export class CustomerLoadDetailsComponent implements OnInit {
  totalLoads: number = 0;
  activeLoads: number = 0;
  onTimePercentage: number = 0;
  customerId: number | null = null;
  customerName: string = '';
  chartData: any;
  chartOptions: any;
  loads: any[] = [];
  searchTerm: string = '';
  selectedStatus: string | null = null;
  selectedChartRange: string = '6M';
  customers: any[] = [];
  
  statusFilters = [
    { label: 'Delivered', value: 'Delivered' },
    { label: 'Scheduled', value: 'Scheduled' }
  ];

  chartRangeOptions = [
    { label: 'Last 3 Months', value: '3M' },
    { label: 'Last 6 Months', value: '6M' },
    { label: 'Last Year', value: '1Y' },
    { label: 'Year to Date', value: 'YTD' }
  ];

  constructor(
    private route: ActivatedRoute,
    private dataService: DataServiceService
  ) {}

  ngOnInit() {
    this.customerId = Number(this.route.snapshot.paramMap.get('id'));
    this.loadCustomerData();
    this.loadCustomerLoads();
    
    // Only initialize chart data after we have the customer ID
    if (this.customerId) {
      this.initChartData();
    }
    
    this.dataService.getCustomerLoadDetails(this.customerId).subscribe(data => {
      this.totalLoads = data.total_loads;
      this.activeLoads = data.active_loads;
      this.onTimePercentage = data.on_time_delivery_percentage;
    });

    this.dataService.getAllCustomers().subscribe(customers => {
      this.customers = customers;
    });
  }

  private loadCustomerData() {
    // Get customer name from locations table
    this.dataService.getAllCustomers().subscribe(locations => {
      const location = locations.find((loc: { customer_id: number | null; }) => loc.customer_id === this.customerId);
      this.customerName = location?.name || 'Unknown Customer';
    });
  }

  private initChartData() {
    const documentStyle = getComputedStyle(document.documentElement);
    
    // Fetch real chart data from the API
    this.dataService.getCustomerChartData(this.customerId!, this.selectedChartRange).subscribe(chartData => {
      this.chartData = {
        labels: chartData.labels,
        datasets: [
          {
            label: 'Total Orders',
            data: chartData.datasets[0].data,
            borderColor: documentStyle.getPropertyValue('--primary-color'),
            tension: 0.4,
            yAxisID: 'y'
          }
        ]
      };

      this.chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 2,
        plugins: {
          legend: {
            labels: {
              color: documentStyle.getPropertyValue('--text-color')
            }
          }
        },
        scales: {
          x: {
            ticks: {
              color: documentStyle.getPropertyValue('--text-color')
            },
            grid: {
              color: documentStyle.getPropertyValue('--surface-border')
            }
          },
          y: {
            type: 'linear',
            display: true,
            position: 'left',
            ticks: {
              color: documentStyle.getPropertyValue('--text-color')
            },
            grid: {
              color: documentStyle.getPropertyValue('--surface-border')
            }
          }
        }
      };
    });
  }

  onChartRangeChange() {
    this.initChartData();
  }

  private loadCustomerLoads() {
    if (this.customerId) {
      this.dataService.getOrders(undefined, undefined, this.customerId).subscribe(data => {
        this.loads = data;
      });
    }
  }

  getStatusSeverity(status: string): 'success' | 'warning' | 'danger' | 'info' {
    switch (status) {
      case 'Delivered': return 'success';
      case 'Loaded': return 'info';
      case 'Scheduled': return 'warning';
      default: return 'info';
    }
  }

  getCustomerName(customerId: number): string {
    const customer = this.customers.find((c: { customer_id: number; }) => c.customer_id === customerId);
    return customer?.name || '';
  }
}